import {
  tournamentApi,
  type Tournament,
  type CreateTournamentRequest,
  type UpdateTournamentRequest,
} from "@/shared/api/tournament";

export const tournamentsApi = {
  fetchAll: (params?: {
    status?: string;
    game?: string;
    page?: number;
    limit?: number;
  }) => tournamentApi.getTournaments(params),
  fetchPage: (params: {
    page: number;
    limit: number;
    search?: string;
    status?: string;
    sortBy?: string;
    sortDir?: string;
  }) => tournamentApi.getTournamentsPaged(params),
  fetchById: (id: string) => tournamentApi.getTournamentById(id),
  create: (data: CreateTournamentRequest) =>
    tournamentApi.createTournament(data),
  update: (id: string, data: UpdateTournamentRequest) =>
    tournamentApi.updateTournament(id, data),
  remove: (id: string) => tournamentApi.deleteTournament(id),
};

export type { Tournament, CreateTournamentRequest, UpdateTournamentRequest };
